import { get } from 'lodash-es';
import React from 'react';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import { makeStyles } from 'tss-react/mui';
import type { User } from '../../types/User';
import FollowToggle from './follow-toggle';
import MaterialLinkButton from '../material-link-button';
import { useAppContext } from '../../contexts/app';
import UserNotificationPreferenceToggle from './notification-preference-toggle';

const useStyles = makeStyles()((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(2, 0)
  },
  headerLeft: {
    flexGrow: 1,
    paddingRight: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    width: 60,
    height: 60,
    marginRight: theme.spacing(1)
  },
  title: {
    margin: 0
  },
  editProfileButton: {
    marginLeft: theme.spacing(2)
  },
  notificationToggle: {
    marginRight: theme.spacing(1),
  },
}));

type Props = {
  user?: User;
};

const UserHeader = ({ user }: Props) => {
  const { loggedInUser } = useAppContext();
  const { classes } = useStyles();

  return (
    <div className={classes.header}>
      <div className={classes.headerLeft}>
        <Avatar
          alt={user.displayName}
          src={user.avatar.med.url}
          className={classes.avatar}
        />
        <div>
          <Typography variant="h1" className={classes.title}>
            {user.displayName}
          </Typography>
          <span>{user.primaryCity.name}</span>
        </div>
      </div>
      <UserNotificationPreferenceToggle user={user} className={classes.notificationToggle} />
      <FollowToggle user={user} />
      {loggedInUser && get(loggedInUser, 'id') === user.id && (
        <MaterialLinkButton
          href="/account"
          variant="outlined"
          className={classes.editProfileButton}
        >
          Edit Profile
        </MaterialLinkButton>
      )}
    </div>
  );
}

export default UserHeader;
